import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getReceipt(params) {
	return client.get("tunnel/api/pos/purchase-order/data", {
		params: params,
	});
}

function getDetailSO(params) {
	return client.get("tunnel/api/pos/purchase-order/detail", {
		params: params,
	});
}

function getDetailReceipt(params) {
	return client.get("tunnel/api/pos/purchase-order/detail-receipt", {
		params: params,
	});
}

function addReceipt(params) {
	return client.post("tunnel/api/pos/purchase-order/scan-sdo", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getSerialStashed(params) {
	return client.get("tunnel/api/pos/purchase-order/serial_stashed", {
		params: params,
	});
}

function syncSerial(params) {
	return client.post("tunnel/api/pos/purchase-order/scan", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function proccessSerial(params) {
	return client.post("tunnel/api/pos/purchase-order/process_new", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelSO(params) {
	return client.post("tunnel/api/pos/purchase-order/cancel_so", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getReceipt,
	getDetailSO,
	getDetailReceipt,
	addReceipt,
	getSerialStashed,
	syncSerial,
	proccessSerial,
	cancelSO
};
